import { Measurement, MeasurementDimension } from '../query.types';

const sharedCloudDimensions: Record<string, MeasurementDimension> = {
  Account: {
    Mask: 8,
    Type: 'string',
    Column: 'STR03',
    Label: 'Account',
    Shared: true
  },
  ApiName: {
    Mask: 1,
    Type: 'string',
    Column: 'STR00',
    Label: 'API Name',
    Shared: true
  },
  CollectingAccount: {
    Mask: 16,
    Type: 'string',
    Column: 'STR04',
    Label: 'Collecting Account',
    Shared: true
  }
};

const cloudMetrics: Measurement[] = [
  {
    measurement: '/cloud/AWS',
    storage: {
      Metrics: {},
      Dimensions: {
        ...sharedCloudDimensions
      }
    }
  },
  {
    measurement: '/cloud/AWS/ApiGateway',
    storage: {
      Metrics: {
        Count: {
          Mask: 16,
          Type: 'float',
          Column: 'km_float004',
          Label: 'Count'
        },
        Latency: {
          Mask: 1,
          Type: 'float',
          Column: 'km_float000',
          Label: 'Latency'
        },
        '4XXError': {
          Mask: 4,
          Type: 'float',
          Column: 'km_float002',
          Label: '4xx Error'
        },
        '5XXError': {
          Mask: 2,
          Type: 'float',
          Column: 'km_float001',
          Label: '5xx Error'
        },
        IntegrationLatency: {
          Mask: 8,
          Type: 'float',
          Column: 'km_float003',
          Label: 'Integration Latency'
        }
      },
      Dimensions: {
        Stage: {
          Mask: 4,
          Type: 'string',
          Column: 'STR02',
          Label: 'Stage'
        },
        Region: {
          Mask: 2,
          Type: 'string',
          Column: 'STR01',
          Label: 'Region'
        }
      },
      AppProtocol: 0,
      Description: '',
      SourceTimestampCol: ''
    }
  },
  {
    measurement: '/cloud/AWS/ApplicationELB',
    storage: {
      Metrics: {
        PeakLCUs: {
          Mask: 8388608,
          Type: 'float',
          Column: 'km_float023',
          Label: 'Peak Lc Us'
        },
        ConsumedLCUs: {
          Mask: 524288,
          Type: 'float',
          Column: 'km_float019',
          Label: 'Consumed Lc Us'
        },
        RequestCount: {
          Mask: 1,
          Type: 'float',
          Column: 'km_float000',
          Label: 'Request Count'
        },
        ProcessedBytes: {
          Mask: 16384,
          Type: 'float',
          Column: 'km_float014',
          Label: 'Processed Bytes'
        },
        HealthyStateDNS: {
          Mask: 128,
          Type: 'float',
          Column: 'km_float007',
          Label: 'Healthy State DNS'
        },
        RuleEvaluations: {
          Mask: 8192,
          Type: 'float',
          Column: 'km_float013',
          Label: 'Rule Evaluations'
        },
        HealthyHostCount: {
          Mask: 512,
          Type: 'float',
          Column: 'km_float009',
          Label: 'Healthy Host Count'
        },
        UnhealthyStateDNS: {
          Mask: 2,
          Type: 'float',
          Column: 'km_float001',
          Label: 'Unhealthy State DNS'
        },
        AnomalousHostCount: {
          Mask: 32,
          Type: 'float',
          Column: 'km_float005',
          Label: 'Anomalous Host Count'
        },
        MitigatedHostCount: {
          Mask: 8,
          Type: 'float',
          Column: 'km_float003',
          Label: 'Mitigated Host Count'
        },
        NewConnectionCount: {
          Mask: 1024,
          Type: 'float',
          Column: 'km_float010',
          Label: 'New Connection Count'
        },
        TargetResponseTime: {
          Mask: 2097152,
          Type: 'float',
          Column: 'km_float021',
          Label: 'Target Response Time'
        },
        UnHealthyHostCount: {
          Mask: 64,
          Type: 'float',
          Column: 'km_float006',
          Label: 'Un Healthy Host Count'
        },
        HealthyStateRouting: {
          Mask: 256,
          Type: 'float',
          Column: 'km_float008',
          Label: 'Healthy State Routing'
        },
        ActiveConnectionCount: {
          Mask: 2048,
          Type: 'float',
          Column: 'km_float011',
          Label: 'Active Connection Count'
        },
        RequestCountPerTarget: {
          Mask: 16,
          Type: 'float',
          Column: 'km_float004',
          Label: 'Request Count Per Target'
        },
        UnhealthyStateRouting: {
          Mask: 4,
          Type: 'float',
          Column: 'km_float002',
          Label: 'Unhealthy State Routing'
        },
        HTTPCode_ELB_4XX_Count: {
          Mask: 4096,
          Type: 'float',
          Column: 'km_float012',
          Label: 'HTTP Code ELB 4xx Count'
        },
        HTTPCode_ELB_5XX_Count: {
          Mask: 1048576,
          Type: 'float',
          Column: 'km_float020',
          Label: 'HTTP Code ELB 5xx Count'
        },
        HTTPCode_Target_4XX_Count: {
          Mask: 4194304,
          Type: 'float',
          Column: 'km_float022',
          Label: 'HTTP Code Target 4xx Count'
        },
        HTTP_Fixed_Response_Count: {
          Mask: 32768,
          Type: 'float',
          Column: 'km_float015',
          Label: 'HTTP Fixed Response Count'
        },
        ClientTLSNegotiationErrorCount: {
          Mask: 65536,
          Type: 'float',
          Column: 'km_float016',
          Label: 'Client TLS Negotiation Error Count'
        },
        ForwardedInvalidHeaderRequestCount: {
          Mask: 262144,
          Type: 'float',
          Column: 'km_float018',
          Label: 'Forwarded Invalid Header Request Count'
        },
        DesyncMitigationMode_NonCompliant_Request_Count: {
          Mask: 131072,
          Type: 'float',
          Column: 'km_float017',
          Label: 'Desync Mitigation Mode Non Compliant Request Count'
        }
      },
      Dimensions: {
        Region: {
          Mask: 16,
          Type: 'string',
          Column: 'STR04',
          Label: 'Region'
        },
        TargetGroup: {
          Mask: 1,
          Type: 'string',
          Column: 'STR00',
          Label: 'Target Group'
        },
        LoadBalancer: {
          Mask: 2,
          Type: 'string',
          Column: 'STR01',
          Label: 'Load Balancer'
        },
        AvailabilityZone: {
          Mask: 8,
          Type: 'string',
          Column: 'STR03',
          Label: 'Availability Zone'
        }
      },
      EntityType: '',
      AppProtocol: 0,
      Description: '',
      SourceTimestampCol: ''
    }
  },
  {
    measurement: '/cloud/AWS/DX',
    storage: {
      Metrics: {
        ConnectionState: {
          Mask: 4,
          Type: 'float',
          Column: 'km_float002',
          Label: 'Connection State'
        },
        VirtualInterfaceBpsEgress: {
          Mask: 8,
          Type: 'float',
          Column: 'km_float003',
          Label: 'Virtual Interface BPS Egress'
        },
        VirtualInterfacePpsEgress: {
          Mask: 1,
          Type: 'float',
          Column: 'km_float000',
          Label: 'Virtual Interface PPS Egress'
        },
        VirtualInterfaceBpsIngress: {
          Mask: 2,
          Type: 'float',
          Column: 'km_float001',
          Label: 'Virtual Interface BPS Ingress'
        },
        VirtualInterfacePpsIngress: {
          Mask: 16,
          Type: 'float',
          Column: 'km_float004',
          Label: 'Virtual Interface PPS Ingress'
        }
      },
      Dimensions: {
        Region: {
          Mask: 2,
          Type: 'string',
          Column: 'STR01',
          Label: 'Region'
        },
        Account: {
          Mask: 8,
          Type: 'string',
          Column: 'STR03',
          Label: 'Account'
        },
        ConnectionId: {
          Mask: 1,
          Type: 'string',
          Column: 'STR00',
          Label: 'Connection Id'
        },
        CollectingAccount: {
          Mask: 16,
          Type: 'string',
          Column: 'STR04',
          Label: 'Collecting Account'
        },
        VirtualInterfaceId: {
          Mask: 4,
          Type: 'string',
          Column: 'STR02',
          Label: 'Virtual Interface Id'
        }
      },
      AppProtocol: 0,
      Description: '',
      SourceTimestampCol: ''
    }
  },
  {
    measurement: '/cloud/AWS/EC2',
    storage: {
      Metrics: {
        NetworkIn: {
          Mask: 2048,
          Type: 'float',
          Column: 'km_float011',
          Label: 'Network In'
        },
        EBSReadOps: {
          Mask: 16,
          Type: 'float',
          Column: 'km_float004',
          Label: 'EBS Read Ops'
        },
        NetworkOut: {
          Mask: 4096,
          Type: 'float',
          Column: 'km_float012',
          Label: 'Network Out'
        },
        DiskReadOps: {
          Mask: 4194304,
          Type: 'float',
          Column: 'km_float022',
          Label: 'Disk Read Ops'
        },
        EBSWriteOps: {
          Mask: 64,
          Type: 'float',
          Column: 'km_float006',
          Label: 'EBS Write Ops'
        },
        DiskWriteOps: {
          Mask: 262144,
          Type: 'float',
          Column: 'km_float018',
          Label: 'Disk Write Ops'
        },
        EBSReadBytes: {
          Mask: 2,
          Type: 'float',
          Column: 'km_float001',
          Label: 'EBS Read Bytes'
        },
        DiskReadBytes: {
          Mask: 1048576,
          Type: 'float',
          Column: 'km_float020',
          Label: 'Disk Read Bytes'
        },
        'EBSIOBalance%': {
          Mask: 32768,
          Type: 'float',
          Column: 'km_float015',
          Label: 'Ebsio Balance'
        },
        EBSWriteBytes: {
          Mask: 256,
          Type: 'float',
          Column: 'km_float008',
          Label: 'EBS Write Bytes'
        },
        CPUCreditUsage: {
          Mask: 524288,
          Type: 'float',
          Column: 'km_float019',
          Label: 'CPU Credit Usage'
        },
        CPUUtilization: {
          Mask: 1,
          Type: 'float',
          Column: 'km_float000',
          Label: 'CPU Utilization'
        },
        DiskWriteBytes: {
          Mask: 2097152,
          Type: 'float',
          Column: 'km_float021',
          Label: 'Disk Write Bytes'
        },
        'EBSByteBalance%': {
          Mask: 16384,
          Type: 'float',
          Column: 'km_float014',
          Label: 'EBS Byte Balance'
        },
        MetadataNoToken: {
          Mask: 32,
          Type: 'float',
          Column: 'km_float005',
          Label: 'Metadata No Token'
        },
        CPUCreditBalance: {
          Mask: 65536,
          Type: 'float',
          Column: 'km_float016',
          Label: 'CPU Credit Balance'
        },
        NetworkPacketsIn: {
          Mask: 512,
          Type: 'float',
          Column: 'km_float009',
          Label: 'Network Packets In'
        },
        NetworkPacketsOut: {
          Mask: 1024,
          Type: 'float',
          Column: 'km_float010',
          Label: 'Network Packets Out'
        },
        StatusCheckFailed: {
          Mask: 128,
          Type: 'float',
          Column: 'km_float007',
          Label: 'Status Check Failed'
        },
        CPUSurplusCreditBalance: {
          Mask: 8388608,
          Type: 'float',
          Column: 'km_float023',
          Label: 'CPU Surplus Credit Balance'
        },
        MetadataNoTokenRejected: {
          Mask: 16777216,
          Type: 'float',
          Column: 'km_float024',
          Label: 'Metadata No Token Rejected'
        },
        CPUSurplusCreditsCharged: {
          Mask: 131072,
          Type: 'float',
          Column: 'km_float017',
          Label: 'CPU Surplus Credits Charged'
        },
        StatusCheckFailed_System: {
          Mask: 8,
          Type: 'float',
          Column: 'km_float003',
          Label: 'Status Check Failed System'
        },
        StatusCheckFailed_Instance: {
          Mask: 8192,
          Type: 'float',
          Column: 'km_float013',
          Label: 'Status Check Failed Instance'
        },
        StatusCheckFailed_AttachedEBS: {
          Mask: 4,
          Type: 'float',
          Column: 'km_float002',
          Label: 'Status Check Failed Attached EBS'
        }
      },
      Dimensions: {
        Region: {
          Mask: 32,
          Type: 'string',
          Column: 'STR05',
          Label: 'Region'
        },
        Account: {
          Mask: 8,
          Type: 'string',
          Column: 'STR03',
          Label: 'Account'
        },
        ImageId: {
          Mask: 1,
          Type: 'string',
          Column: 'STR00',
          Label: 'Image Id'
        },
        InstanceId: {
          Mask: 2,
          Type: 'string',
          Column: 'STR01',
          Label: 'Instance Id'
        },
        InstanceType: {
          Mask: 16,
          Type: 'string',
          Column: 'STR04',
          Label: 'Instance Type'
        },
        CollectingAccount: {
          Mask: 64,
          Type: 'string',
          Column: 'STR06',
          Label: 'Collecting Account'
        },
        AutoScalingGroupName: {
          Mask: 4,
          Type: 'string',
          Column: 'STR02',
          Label: 'Auto Scaling Group Name'
        }
      },
      AppProtocol: 0,
      Description: '',
      SourceTimestampCol: ''
    }
  },
  {
    measurement: '/cloud/AWS/ELB',
    storage: {
      Metrics: {
        Latency: {
          Mask: 16,
          Type: 'float',
          Column: 'km_float004',
          Label: 'Latency'
        },
        RequestCount: {
          Mask: 4,
          Type: 'float',
          Column: 'km_float002',
          Label: 'Request Count'
        },
        HealthyHostCount: {
          Mask: 32,
          Type: 'float',
          Column: 'km_float005',
          Label: 'Healthy Host Count'
        },
        SurgeQueueLength: {
          Mask: 8,
          Type: 'float',
          Column: 'km_float003',
          Label: 'Surge Queue Length'
        },
        UnHealthyHostCount: {
          Mask: 64,
          Type: 'float',
          Column: 'km_float006',
          Label: 'Un Healthy Host Count'
        },
        BackendConnectionErrors: {
          Mask: 512,
          Type: 'float',
          Column: 'km_float009',
          Label: 'Backend Connection Errors'
        },
        EstimatedProcessedBytes: {
          Mask: 2,
          Type: 'float',
          Column: 'km_float001',
          Label: 'Estimated Processed Bytes'
        },
        EstimatedALBConsumedLCUs: {
          Mask: 256,
          Type: 'float',
          Column: 'km_float008',
          Label: 'Estimated ALB Consumed Lc Us'
        },
        EstimatedALBNewConnectionCount: {
          Mask: 1,
          Type: 'float',
          Column: 'km_float000',
          Label: 'Estimated ALB New Connection Count'
        },
        EstimatedALBActiveConnectionCount: {
          Mask: 128,
          Type: 'float',
          Column: 'km_float007',
          Label: 'Estimated ALB Active Connection Count'
        }
      },
      Dimensions: {
        Region: {
          Mask: 2,
          Type: 'string',
          Column: 'STR01',
          Label: 'Region'
        },
        Service: {
          Mask: 32,
          Type: 'string',
          Column: 'STR05',
          Label: 'Service'
        },
        Namespace: {
          Mask: 64,
          Type: 'string',
          Column: 'STR06',
          Label: 'Namespace'
        },
        AvailabilityZone: {
          Mask: 8,
          Type: 'string',
          Column: 'STR03',
          Label: 'Availability Zone'
        },
        LoadBalancerName: {
          Mask: 1,
          Type: 'string',
          Column: 'STR00',
          Label: 'Load Balancer Name'
        },
        CollectingAccount: {
          Mask: 16,
          Type: 'string',
          Column: 'STR04',
          Label: 'Collecting Account'
        }
      },
      AppProtocol: 0,
      Description: '',
      SourceTimestampCol: ''
    }
  },
  {
    measurement: '/cloud/AWS/NATGateway',
    storage: {
      Metrics: {
        BytesOutToSource: {
          Mask: 64,
          Type: 'float',
          Column: 'km_float006',
          Label: 'Bytes Out To Source'
        },
        IdleTimeoutCount: {
          Mask: 32768,
          Type: 'float',
          Column: 'km_float015',
          Label: 'Idle Timeout Count'
        },
        PacketsDropCount: {
          Mask: 4,
          Type: 'float',
          Column: 'km_float002',
          Label: 'Packets Drop Count'
        },
        BytesInFromSource: {
          Mask: 16384,
          Type: 'float',
          Column: 'km_float014',
          Label: 'Bytes In From Source'
        },
        PacketsOutToSource: {
          Mask: 1024,
          Type: 'float',
          Column: 'km_float010',
          Label: 'Packets Out To Source'
        },
        PeakBytesPerSecond: {
          Mask: 128,
          Type: 'float',
          Column: 'km_float007',
          Label: 'Peak Bytes Per Second'
        },
        ErrorPortAllocation: {
          Mask: 32,
          Type: 'float',
          Column: 'km_float005',
          Label: 'Error Port Allocation'
        },
        PacketsInFromSource: {
          Mask: 4096,
          Type: 'float',
          Column: 'km_float012',
          Label: 'Packets In From Source'
        },
        PeakPacketsPerSecond: {
          Mask: 2048,
          Type: 'float',
          Column: 'km_float011',
          Label: 'Peak Packets Per Second'
        },
        ActiveConnectionCount: {
          Mask: 8,
          Type: 'float',
          Column: 'km_float003',
          Label: 'Active Connection Count'
        },
        BytesOutToDestination: {
          Mask: 8192,
          Type: 'float',
          Column: 'km_float013',
          Label: 'Bytes Out To Destination'
        },
        BytesInFromDestination: {
          Mask: 512,
          Type: 'float',
          Column: 'km_float009',
          Label: 'Bytes In From Destination'
        },
        ConnectionAttemptCount: {
          Mask: 256,
          Type: 'float',
          Column: 'km_float008',
          Label: 'Connection Attempt Count'
        },
        PacketsOutToDestination: {
          Mask: 2,
          Type: 'float',
          Column: 'km_float001',
          Label: 'Packets Out To Destination'
        },
        PacketsInFromDestination: {
          Mask: 1,
          Type: 'float',
          Column: 'km_float000',
          Label: 'Packets In From Destination'
        },
        ConnectionEstablishedCount: {
          Mask: 16,
          Type: 'float',
          Column: 'km_float004',
          Label: 'Connection Established Count'
        }
      },
      Dimensions: {
        Region: {
          Mask: 8,
          Type: 'string',
          Column: 'STR03',
          Label: 'Region'
        },
        Account: {
          Mask: 1,
          Type: 'string',
          Column: 'STR00',
          Label: 'Account'
        },
        NatGatewayId: {
          Mask: 4,
          Type: 'string',
          Column: 'STR02',
          Label: 'Nat Gateway Id'
        },
        CollectingAccount: {
          Mask: 2,
          Type: 'string',
          Column: 'STR01',
          Label: 'Collecting Account'
        }
      },
      AppProtocol: 0,
      Description: '',
      SourceTimestampCol: ''
    }
  },
  {
    measurement: '/cloud/AWS/PrivateLinkEndpoints',
    storage: {
      Metrics: {
        BytesProcessed: {
          Mask: 2,
          Type: 'float',
          Column: 'km_float001',
          Label: 'Bytes Processed'
        },
        NewConnections: {
          Mask: 8,
          Type: 'float',
          Column: 'km_float003',
          Label: 'New Connections'
        },
        PacketsDropped: {
          Mask: 4,
          Type: 'float',
          Column: 'km_float002',
          Label: 'Packets Dropped'
        },
        ActiveConnections: {
          Mask: 16,
          Type: 'float',
          Column: 'km_float004',
          Label: 'Active Connections'
        },
        RstPacketsReceived: {
          Mask: 1,
          Type: 'float',
          Column: 'km_float000',
          Label: 'Rst Packets Received'
        }
      },
      Dimensions: {
        Region: {
          Mask: 128,
          Type: 'string',
          Column: 'STR07',
          Label: 'Region'
        },
        'VPC Id': {
          Mask: 8,
          Type: 'string',
          Column: 'STR03',
          Label: 'VPC Id'
        },
        Account: {
          Mask: 16,
          Type: 'string',
          Column: 'STR04',
          Label: 'Account'
        },
        'Subnet Id': {
          Mask: 1,
          Type: 'string',
          Column: 'STR00',
          Label: 'Subnet Id'
        },
        'Service Name': {
          Mask: 2,
          Type: 'string',
          Column: 'STR01',
          Label: 'Service Name'
        },
        'Endpoint Type': {
          Mask: 64,
          Type: 'string',
          Column: 'STR06',
          Label: 'Endpoint Type'
        },
        'VPC Endpoint Id': {
          Mask: 4,
          Type: 'string',
          Column: 'STR02',
          Label: 'VPC Endpoint Id'
        }
      },
      AppProtocol: 0,
      Description: '',
      SourceTimestampCol: ''
    }
  },
  {
    measurement: '/cloud/AWS/Route53',
    storage: {
      Metrics: {
        DNSQueries: {
          Mask: 1,
          Type: 'float',
          Column: 'km_float000',
          Label: 'DNS Queries'
        }
      },
      Dimensions: {
        Region: {
          Mask: 1,
          Type: 'string',
          Column: 'STR00',
          Label: 'Region'
        },
        Account: {
          Mask: 2,
          Type: 'string',
          Column: 'STR01',
          Label: 'Account'
        },
        HostedZoneId: {
          Mask: 4,
          Type: 'string',
          Column: 'STR02',
          Label: 'Hosted Zone Id'
        },
        CollectingAccount: {
          Mask: 8,
          Type: 'string',
          Column: 'STR03',
          Label: 'Collecting Account'
        }
      },
      AppProtocol: 0,
      Description: '',
      SourceTimestampCol: ''
    }
  },
  {
    measurement: '/cloud/AWS/TransitGateway',
    storage: {
      Metrics: {
        BytesIn: {
          Mask: 64,
          Type: 'float',
          Column: 'km_float006',
          Label: 'Bytes In'
        },
        BytesOut: {
          Mask: 16,
          Type: 'float',
          Column: 'km_float004',
          Label: 'Bytes Out'
        },
        PacketsIn: {
          Mask: 2,
          Type: 'float',
          Column: 'km_float001',
          Label: 'Packets In'
        },
        PacketsOut: {
          Mask: 1,
          Type: 'float',
          Column: 'km_float000',
          Label: 'Packets Out'
        },
        BytesDropCountNoRoute: {
          Mask: 8,
          Type: 'float',
          Column: 'km_float003',
          Label: 'Bytes Drop Count No Route'
        },
        PacketDropCountNoRoute: {
          Mask: 128,
          Type: 'float',
          Column: 'km_float007',
          Label: 'Packet Drop Count No Route'
        },
        BytesDropCountBlackhole: {
          Mask: 32,
          Type: 'float',
          Column: 'km_float005',
          Label: 'Bytes Drop Count Blackhole'
        },
        PacketDropCountBlackhole: {
          Mask: 4,
          Type: 'float',
          Column: 'km_float002',
          Label: 'Packet Drop Count Blackhole'
        }
      },
      Dimensions: {
        Region: {
          Mask: 4,
          Type: 'string',
          Column: 'STR02',
          Label: 'Region'
        },
        Account: {
          Mask: 1,
          Type: 'string',
          Column: 'STR00',
          Label: 'Account'
        },
        TransitGateway: {
          Mask: 8,
          Type: 'string',
          Column: 'STR03',
          Label: 'Transit Gateway'
        },
        CollectingAccount: {
          Mask: 2,
          Type: 'string',
          Column: 'STR01',
          Label: 'Collecting Account'
        },
        TransitGatewayAttachment: {
          Mask: 16,
          Type: 'string',
          Column: 'STR04',
          Label: 'Transit Gateway Attachment'
        }
      },
      AppProtocol: 0,
      Description: '',
      SourceTimestampCol: ''
    }
  },
  {
    measurement: '/cloud/azure/applicationGateways',
    storage: {
      Metrics: {
        BytesSent: {
          Mask: 512,
          Type: 'float',
          Column: 'km_float009',
          Label: 'Bytes Sent'
        },
        ClientRtt: {
          Mask: 8192,
          Type: 'float',
          Column: 'km_float013',
          Label: 'Client RTT'
        },
        Throughput: {
          Mask: 32768,
          Type: 'float',
          Column: 'km_float015',
          Label: 'Throughput'
        },
        TlsProtocol: {
          Mask: 16,
          Type: 'float',
          Column: 'km_float004',
          Label: 'TLS Protocol'
        },
        ComputeUnits: {
          Mask: 8,
          Type: 'float',
          Column: 'km_float003',
          Label: 'Compute Units'
        },
        BytesReceived: {
          Mask: 4096,
          Type: 'float',
          Column: 'km_float012',
          Label: 'Bytes Received'
        },
        CapacityUnits: {
          Mask: 128,
          Type: 'float',
          Column: 'km_float007',
          Label: 'Capacity Units'
        },
        TotalRequests: {
          Mask: 256,
          Type: 'float',
          Column: 'km_float008',
          Label: 'Total Requests'
        },
        FailedRequests: {
          Mask: 131072,
          Type: 'float',
          Column: 'km_float017',
          Label: 'Failed Requests'
        },
        ResponseStatus: {
          Mask: 2,
          Type: 'float',
          Column: 'km_float001',
          Label: 'Response Status'
        },
        HealthyHostCount: {
          Mask: 1024,
          Type: 'float',
          Column: 'km_float010',
          Label: 'Healthy Host Count'
        },
        BackendConnectTime: {
          Mask: 16384,
          Type: 'float',
          Column: 'km_float014',
          Label: 'Backend Connect Time'
        },
        CurrentConnections: {
          Mask: 1048576,
          Type: 'float',
          Column: 'km_float020',
          Label: 'Current Connections'
        },
        UnhealthyHostCount: {
          Mask: 2097152,
          Type: 'float',
          Column: 'km_float021',
          Label: 'Unhealthy Host Count'
        },
        BackendResponseStatus: {
          Mask: 1,
          Type: 'float',
          Column: 'km_float000',
          Label: 'Backend Response Status'
        },
        NewConnectionsPerSecond: {
          Mask: 262144,
          Type: 'float',
          Column: 'km_float018',
          Label: 'New Connections Per Second'
        },
        FixedBillableCapacityUnits: {
          Mask: 2048,
          Type: 'float',
          Column: 'km_float011',
          Label: 'Fixed Billable Capacity Units'
        },
        ApplicationGatewayTotalTime: {
          Mask: 4,
          Type: 'float',
          Column: 'km_float002',
          Label: 'Application Gateway Total Time'
        },
        BackendLastByteResponseTime: {
          Mask: 65536,
          Type: 'float',
          Column: 'km_float016',
          Label: 'Backend Last Byte Response Time'
        },
        BackendFirstByteResponseTime: {
          Mask: 524288,
          Type: 'float',
          Column: 'km_float019',
          Label: 'Backend First Byte Response Time'
        },
        EstimatedBilledCapacityUnits: {
          Mask: 32,
          Type: 'float',
          Column: 'km_float005',
          Label: 'Estimated Billed Capacity Units'
        },
        AvgRequestCountPerHealthyHost: {
          Mask: 64,
          Type: 'float',
          Column: 'km_float006',
          Label: 'Avg Request Count Per Healthy Host'
        }
      },
      Dimensions: {
        type: {
          Mask: 8,
          Type: 'string',
          Column: 'STR03',
          Label: 'Type'
        },
        resourceName: {
          Mask: 2,
          Type: 'string',
          Column: 'STR01',
          Label: 'Resource Name'
        },
        resourceGroup: {
          Mask: 1,
          Type: 'string',
          Column: 'STR00',
          Label: 'Resource Group'
        },
        subscriptionID: {
          Mask: 4,
          Type: 'string',
          Column: 'STR02',
          Label: 'Subscription Id'
        }
      },
      AppProtocol: 0,
      SourceTimestampCol: ''
    }
  },
  {
    measurement: '/cloud/azure/loadBalancers',
    storage: {
      Metrics: {
        SYNCount: {
          Mask: 32,
          Type: 'float',
          Column: 'km_float005',
          Label: 'Syn Count'
        },
        ByteCount: {
          Mask: 8,
          Type: 'float',
          Column: 'km_float003',
          Label: 'Byte Count'
        },
        PacketCount: {
          Mask: 16,
          Type: 'float',
          Column: 'km_float004',
          Label: 'Packet Count'
        },
        UsedSnatPorts: {
          Mask: 4,
          Type: 'float',
          Column: 'km_float002',
          Label: 'Used Snat Ports'
        },
        AllocatedSnatPorts: {
          Mask: 2,
          Type: 'float',
          Column: 'km_float001',
          Label: 'Allocated Snat Ports'
        },
        SnatConnectionCount: {
          Mask: 1,
          Type: 'float',
          Column: 'km_float000',
          Label: 'Snat Connection Count'
        }
      },
      Dimensions: {
        type: {
          Mask: 2,
          Type: 'string',
          Column: 'STR01',
          Label: 'Type'
        },
        resourceName: {
          Mask: 8,
          Type: 'string',
          Column: 'STR03',
          Label: 'Resource Name'
        },
        resourceGroup: {
          Mask: 4,
          Type: 'string',
          Column: 'STR02',
          Label: 'Resource Group'
        },
        subscriptionID: {
          Mask: 1,
          Type: 'string',
          Column: 'STR00',
          Label: 'Subscription Id'
        }
      },
      AppProtocol: 0,
      SourceTimestampCol: ''
    }
  },
  {
    measurement: '/cloud/azure/Storage',
    storage: {
      Metrics: {
        Egress: {
          Mask: 2,
          Type: 'float',
          Column: 'km_float001',
          Label: 'Egress'
        },
        Ingress: {
          Mask: 8,
          Type: 'float',
          Column: 'km_float003',
          Label: 'Ingress'
        },
        Availability: {
          Mask: 64,
          Type: 'float',
          Column: 'km_float006',
          Label: 'Availability'
        },
        Transactions: {
          Mask: 4,
          Type: 'float',
          Column: 'km_float002',
          Label: 'Transactions'
        },
        UsedCapacity: {
          Mask: 1,
          Type: 'float',
          Column: 'km_float000',
          Label: 'Used Capacity'
        },
        SuccessE2ELatency: {
          Mask: 32,
          Type: 'float',
          Column: 'km_float005',
          Label: 'Success E2e Latency'
        },
        SuccessServerLatency: {
          Mask: 16,
          Type: 'float',
          Column: 'km_float004',
          Label: 'Success Server Latency'
        }
      },
      Dimensions: {
        type: {
          Mask: 1,
          Type: 'string',
          Column: 'STR00',
          Label: 'Type'
        },
        resourceName: {
          Mask: 4,
          Type: 'string',
          Column: 'STR02',
          Label: 'Resource Name'
        },
        resourceGroup: {
          Mask: 2,
          Type: 'string',
          Column: 'STR01',
          Label: 'Resource Group'
        },
        subscriptionID: {
          Mask: 8,
          Type: 'string',
          Column: 'STR03',
          Label: 'Subscription Id'
        }
      },
      AppProtocol: 0,
      Description: '',
      SourceTimestampCol: ''
    }
  }
];

export default cloudMetrics;
